import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../Configurations/AuthContext';
import TopHeader from './TopHeader';

export default function AppLayout() {
  const { user } = useAuth();
  
  return (
    <div id="layout-wrapper">
      <TopHeader />
      <Outlet /> 
    </div>
  );
}